import React from "react";
import styles from "./styles.module.scss";
import { ActionIcon } from "@td/ui";

const ActionButton = React.memo((props) => (
  <button
    {...props}
    className={styles.actionButton}
  >
    <ActionIcon
      width={14}
      height={14}
      fill="#262626"
    />
  </button>
));

export default ActionButton;
